import React from 'react'
import { useState } from 'react'
import Cart from './Cart'
import { toast } from 'react-toastify';
import Product from './Products';
const Info = ({onAdd, product,minus,count, plus}) => {

 const notify = () => toast.success("Added to cart");

 let addCart = () => {
     let add = count + 0
    }
  return (
<div className="text">
    <h6 style={{color: 'orangered'}}>SNEAKERS COMPANY</h6>
<h2> Fall Limited Edition <br/> Sneakers </h2>
          <blockquote>  
            <p id="text"> These low-profile sneakers are your perfect casual wear companion. 
            Featuring a durable rubber outer sole, they’ll withstand everything the weather can offer.
          </p> </blockquote> 
                  <div class="btn-text" style= {{display: 'flex', gap: '30px'}}>
           < h4> $125.00</h4>
           <h6 style={{backgroundColor: 'orange', opacity: '0.7', color: 'orangered', textAlign: 'center'}}> 50%</h6>
                  </div>
                  <h6 style={{color: 'gray',textDecoration:'line-through'}}>$350</h6>
                  <div className="cart">
                    <div className="count">
                    <div className="minus">
                    <i onClick={minus} class ="bi bi-dash"></i>
                    </div>
                    <div className="number">
                        <p> {count} </p>
                    </div>
                    
                    <div className="plus">
                    <i onClick={plus} class="bi bi-plus"></i>
                    </div> </div>
   <div className="btns">
      <button onClick={() => console.log(onAdd(product), notify())}className='btn'>Add to Cart </button>
   </div>
                  </div>

</div>
    )
}

export default Info